<template>
  <v-card>
    <v-card-title>{{ $t('minutegiftform.title') }}</v-card-title>
    <v-card-text v-if="loading">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-card-text>
    <v-card-text class="pb-0">
      <v-text-field type="number" :label="$t('minutegiftform.labels.minutes')" v-model="minutes"></v-text-field>
      <v-text-field :label="$t('minutegiftform.labels.reason')" v-model="reason"></v-text-field>
      <p class="mb-0">{{ $t('minutegiftform.text', { minutes, price: pricePerMinute }) }}</p>
    </v-card-text>
    <v-card-row actions>
      <v-btn primary light block @click.native.stop="submit()">{{ $t('minutegiftform.submit', { price, minutes }) }}</v-btn>
    </v-card-row>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      minutes: 10,
      reason: ''
    }
  },
  computed: {
    ...mapGetters({
      platform: 'skiliko/session/currentPlatform',
      loading: 'skiliko/minuteGifts/isLoading'
    }),
    pricePerMinute () {
      const setting = this.platform.settings.price_per_minute
      const price =
        setting === undefined || setting === null
          ? process.env.DEFAULT_PRICE_PER_MINUTE
          : setting
      return price / 100
    },
    price () {
      return this.minutes * this.pricePerMinute
    }
  },
  methods: {
    ...mapActions({
      create: 'skiliko/minuteGifts/create'
    }),
    async submit () {
      const transaction = await this.create({
        user_id: this.user.id,
        minutes: this.minutes,
        reason: this.reason
      })
      if (transaction.payed_at) {
        return this.$emit('created')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MinuteGiftForm.vue